'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import ContentGeneratorWizard from './components/ContentGeneratorWizard';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';

export default function ContentGeneratorPage() {
  return (
    <AppLayout currentPath="/content-generator">
      <section
        className="min-h-screen bg-background px-6 lg:px-8 xl:px-10 py-6 max-w-screen-2xl mx-auto"
        aria-label="Content Generator"
      >
        <header className="mb-6">
          <p className="section-label mb-1">KI-Automatisierung</p>
          <h1 className="text-2xl font-800 text-white tracking-tight">Content Generator</h1>
          <p className="text-sm text-muted mt-1">
            Transformiere einen Input in <span className="text-accent font-600">14 Tage plattformspezifischen Content</span> — in einer einzigen Session.
          </p>
        </header>
        <ErrorBoundary
          title="Generator nicht verfügbar"
          description="Der Content Generator ist momentan nicht erreichbar. Bitte lade die Seite neu oder versuche es später erneut."
        >
          <ContentGeneratorWizard />
        </ErrorBoundary>
      </section>
    </AppLayout>
  );
}